import React from "react";
import styles from "./SharedReferralCard.module.css";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "../../atoms/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  BsInstagram,
  BsTwitterX,
  BsFacebook,
  BsWhatsapp,
  BsLinkedin,
} from "react-icons/bs";
import { CopyButton } from "../../molecules/CopyLink/CopyLink";

interface ShareReferralCardProps {
  userId: string;
}

export const ShareReferralCard: React.FC<ShareReferralCardProps> = ({
  userId,
}) => {
  const navigate = useNavigate();

  // Obtiene la URL base de las variables de entorno o de la URL actual.
  // Esto hace que el enlace funcione tanto en desarrollo como en producción.
  const baseUrl = process.env.REACT_APP_BASE_URL || globalThis.location.origin;
  const referralLink = `${baseUrl}/register?ref=${userId}`;
  const candidateName = process.env.REACT_APP_CANDIDATE_NAME_SHORT || "Alejo";
  const envShareText = process.env.REACT_APP_SHARE_TEXT;

  const shareText = envShareText
    ? encodeURIComponent(envShareText)
    : encodeURIComponent(
        `¡Únete a la red de amigos de ${candidateName} con mi enlace:`
      );

  const navigateToWhatsappGroups = () => {
    navigate("/whatsapp-groups");
  };

  return (
    <div className="card max-w-lg w-full">
      <h3 className="text-2xl font-bold mb-7 mt-7">¡Comparte!</h3>
      <p className="text-gray-500 mb-6 text-center">
        Invita a tus amigos a registrarse escaneando el siguiente codigo QR o
        compartiendo tu enlace personal.
      </p>

      <div className="flex flex-col w-full md:w-4/5 md:mx-auto gap-6">
        <Button color="primary" type="button" onClick={navigateToWhatsappGroups}>
          Unete a los grupos de whatsapp
        </Button>

        {/* Contenedor para el código QR */}
        <div className={styles.qrContainer}>
          <QRCodeCanvas
            value={referralLink}
            size={128}
            bgColor="#ffffff"
            fgColor="#000000"
          />
        </div>

        <CopyButton referralLink={referralLink} />
        <div className="text-center font-bold text-gray-400 text-sm">Comparte el link en tus redes sociales</div>

        {/* Grupo de botones para compartir */}
        <div className={styles.shareButtons}>
          <a
            href={`https://api.whatsapp.com/send?text=${shareText}%20${encodeURIComponent(
              referralLink
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.shareButton} ${styles.whatsapp}`}
            aria-label="Compartir en WhatsApp"
          >
            <BsWhatsapp />
          </a>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              referralLink
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.shareButton} ${styles.facebook}`}
            aria-label="Compartir en Facebook"
          >
            <BsFacebook />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              referralLink
            )}&text=${shareText}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.shareButton} ${styles.twitter}`}
            aria-label="Compartir en Twitter"
          >
            <BsTwitterX />
          </a>
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.shareButton} ${styles.instagram}`}
            aria-label="Compartir en instagram"
            onClick={() => {
              navigator.clipboard.writeText(referralLink);
            }}
          >
            <BsInstagram />
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              referralLink
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.shareButton} ${styles.linkedin}`}
            aria-label="Compartir en LinkedIn"
          >
            <BsLinkedin />
          </a>
        </div>
      </div>
    </div>
  );
};
